import slice from './slice';
import sagas from './sagas';

export default {
    slice,
    sagas,
};
